<template>
    <v-dialog
      :value="dialogFlag"
      @input="$emit('mychange', $event)"
      @click:outside="closeDialog()"
      max-width="700px"
    >

      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-4 text-center"
          color="rgba(0, 189, 242, 1)"
          dark><span class="text-center">紹介・診療情報提供書作成</span></v-toolbar>


        <v-card-text>
          <div class="text-h6 font-weight-black text-left">紹介・診療情報提供書</div>

          <v-container class="mt-3">
          <v-row class="d-flex justify-space-between">

              <v-col class="text-left" cols="7">
                  <v-row class="d-flex justify-start">
                      <v-col class="text-left align-self-baseline" cols="3">医療機関</v-col>
                      <v-col cols="9" class="align-self-baseline">
                        <v-text-field
                          v-model="iryou_kikan"
                          hint=""
                          append-outer-icon=" "
                        ></v-text-field>
                      </v-col>
                  </v-row>
                  <v-row class="d-flex mt-0">
                      <v-col class="text-left align-self-baseline" cols="3">担当医</v-col>
                      <v-col cols="9" class="align-self-baseline mb-0">
                        <v-text-field
                          v-model="iryou_kikan_tantoui"
                          hint=""
                          append-outer-icon="様"
                        ></v-text-field>
                      </v-col>
                  </v-row>
              </v-col>

              <v-col cols="5" >
                  <v-row class="">
                      <v-col cols="4" class="text-left pb-0">日付</v-col>
                      <v-col cols="8" class="text-left pb-0">{{ today }}</v-col>
                      <v-col cols="12" class="text-left pb-0">〒118-0004</v-col>
                      <v-col cols="12" class="text-left pb-0">東京都西東京市西原町5丁目1-8</v-col>
                      <v-col cols="12" class="text-left pb-0">にしはらクリニックビル歯科・口腔外科</v-col>
                      <v-col cols="4" class="text-left pb-0">TEL</v-col>
                      <v-col cols="8" class="text-left pb-0">042-439-5548</v-col>
                      <v-col cols="4" class="text-left pb-0">院長</v-col>
                      <v-col cols="8" class="text-left pb-0">武田 宗矩</v-col>
                      <v-col cols="4" class="text-left pb-0">担当医</v-col>
                      <v-col cols="8" class="text-left pb-0">{{ data.doctor }}</v-col>
                  </v-row>
              </v-col>
              <v-col cols="12" class="mt-5">
                  <v-row  class="my_border">
                      <v-col cols="5" class="">
                          <v-row  class="rounded-lg">
                              <v-col cols="4" class="pa-0 text-left">
                                  <div>フリガナ</div>
                              </v-col>
                              <v-col cols="8" class="pa-0 pl-1 text-left">
                                  <div>{{ furigana }}</div>
                              </v-col>
                          </v-row>
                          <v-row  class="rounded-lg">
                              <v-col cols="4" class="pa-0 text-left">
                                  <div>患者氏名</div>
                              </v-col>
                              <v-col cols="8" class="pa-0 pl-1 text-left">
                                  <div>{{ name }}</div>
                              </v-col>
                          </v-row>
                          <v-row  class="rounded-lg">
                              <v-col cols="4" class="pa-0 text-left">
                                  <div>生年月日</div>
                              </v-col>
                              <v-col cols="8" class="pa-0 pl-1 text-left">
                                  <div>{{ birthday }}</div>
                              </v-col>
                          </v-row>
                      </v-col>
                      <v-col cols="2">
                          <v-row  class="rounded-lg">
                              <v-col cols="6" class="pa-0 text-left">
                                  <div>&nbsp;</div>
                              </v-col>
                              <v-col cols="6" class="pa-0 pl-1 text-left">
                                  <div>&nbsp;</div>
                              </v-col>
                          </v-row>
                          <v-row  class="rounded-lg">
                              <v-col cols="6" class="pa-0 text-left">
                                  <div>性別</div>
                              </v-col>
                              <v-col cols="6" class="pa-0 pl-1 text-left">
                                  <div>{{ sex }}</div>
                              </v-col>
                          </v-row>
                          <v-row  class="rounded-lg">
                              <v-col cols="6" class="pa-0 text-left">
                                  <div>年齢</div>
                              </v-col>
                              <v-col cols="6" class="pa-0 pl-1 text-left">
                                  <div>{{ age }}歳</div>
                              </v-col>
                          </v-row>
                      </v-col>
                      <v-col cols="5">
                          <v-row  class="rounded-lg">
                              <v-col cols="12" class="pa-0 text-left">
                                  <div>住所</div>
                              </v-col>
                          </v-row>
                          <v-row  class="rounded-lg">
                              <v-col cols="12" class="pa-0 text-left">
                                  <div>{{data.pref_selected}} {{data.city}}</div>
                              </v-col>
                          </v-row>
                          <v-row  class="rounded-lg">
                              <v-col cols="12" class="pa-0 text-left">
                                  <div>{{data.address}}</div>
                              </v-col>
                          </v-row>
                      </v-col>
                  </v-row>
              </v-col>

              <v-col cols="12" class="text-left pa-0 pt-6">傷病名</v-col>
              <v-col cols="12" class="pa-0">
                      <v-textarea
                          outlined
                          rows="2"
                          v-model="syoubyou"
                          value=""
                        ></v-textarea>
              </v-col>
              <v-col cols="12" class="text-left pa-0">紹介目的</v-col>
              <v-col cols="12" class="pa-0">
                      <v-textarea
                          outlined
                          rows="2"
                          v-model="syoukaimokuteki"
                          value=""
                        ></v-textarea>
              </v-col>
              <v-col cols="12" class="text-left pa-0">既往歴及び家族歴</v-col>
              <v-col cols="12" class="pa-0">
                      <v-textarea
                          outlined
                          rows="2"
                          v-model="kioureki"
                          value=""
                        ></v-textarea>
              </v-col>
              <v-col cols="12" class="text-left pa-0">治療経過等</v-col>
              <v-col cols="12" class="pa-0">
                      <v-textarea
                          outlined
                          rows="2"
                          v-model="chiryoukeika"
                          value=""
                        ></v-textarea>
              </v-col>
              <v-col cols="12" class="text-left pa-0">現在の処方</v-col>
              <v-col cols="12" class="pa-0">
                      <v-textarea
                          outlined
                          rows="2"
                          v-model="genzainosyohou"
                          value=""
                        ></v-textarea>
              </v-col>
              <v-col cols="12" class="text-left pa-0">備考</v-col>
              <v-col cols="12" class="pa-0">
                      <v-textarea
                          outlined
                          rows="2"
                          v-model="bikou"
                          value=""
                        ></v-textarea>
              </v-col>


          </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            @click="closeDialog()">キャンセル</v-btn>
          <v-btn dark
            color="rgba(0, 189, 242, 1)"
            @click="print()">印刷</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
/* eslint-disable */



export default {
    props: {
      dialogFlag: Boolean,
      data: Object,
    },

    created() {
        console.log('%ccreated: DialogSyoukaijyou.vue', mycolor.purple);
    },
    data() {
            return {
                iryou_kikan: '',
                iryou_kikan_tantoui: '',
                syoubyou: '',
                syoukaimokuteki: '',
                kioureki: '',
                chiryoukeika: '',
                genzainosyohou: '',
                bikou: '',
            }
    },
    computed: {
        furigana(){
            return this.data.sei_kana + ' ' + this.data.mei_kana
        },
        name(){
            return this.data.sei + ' ' + this.data.mei
        },
        birthday(){
            if(!this.data.birthday){
                return '';
            }
            let re = /(\d+)-(\d+)-(\d+)/;
            let newstr = this.data.birthday.replace(re, '$1年$2月$3日');
            return newstr
        },
        sex(){
            return this.data.sex==='M' ? '男性' : '女性';
        },
        today(){
            var today = new Date();
            let re = /(\d+)-(\d+)-(\d+)/;
            var today_text = today.toISOString().toString().substring(0,10);
            let newstr = today_text.replace(re, '$1年$2月$3日');
            return newstr;
        },
        age(){
            if(!this.data.birthday){
                return '';
            }

            //今日
            var today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            today.setMilliseconds(0);


            //誕生日
            let re = /(\d+)-(\d+)-(\d+)/;
            let month = this.data.birthday.replace(re, '$2');
            let day = this.data.birthday.replace(re, '$3');
            var birthday = new Date( this.data.birthday );

            //今年の誕生日
            var thisYearsBirthdayText = `${today.getFullYear()}-${month}-${day}`;

            var thisYearsBirthday = new Date(thisYearsBirthdayText);
            thisYearsBirthday.setHours(0);
            thisYearsBirthday.setMinutes(0);
            thisYearsBirthday.setSeconds(0);
            thisYearsBirthday.setMilliseconds(0);

            //年齢
            var age = today.getFullYear() - this.data.birthday.replace(/-.+/mg, '');

            if(today < thisYearsBirthday){
                //今年まだ誕生日が来ていない
                age--;
            }

            // console.log(today);
            // console.log(thisYearsBirthdayText);
            // console.log(thisYearsBirthday);
            // console.log(age);
            return age;

        }
    },
    methods: {
        closeDialog(){

            console.log('closeDialog()');
            this.$emit('closeDialog', 'syoukaijyou');
        },


        print(){
            console.log('print()');

            let additional = {
               template_name: 'syoukaijyou',
               today: this.today,
               iryou_kikan: this.iryou_kikan,
               iryou_kikan_tantoui: this.iryou_kikan_tantoui,
               patient: this.data,
               birthday: this.birthday,
               age: this.age,
               sex: this.sex,

               bikou: this.bikou,
               syoubyou: this.syoubyou,
               syoukaimokuteki: this.syoukaimokuteki,
               kioureki: this.kioureki,
               chiryoukeika: this.chiryoukeika,
               genzainosyohou: this.genzainosyohou,
               pref_selected: this.data.pref_selected
            };
            let post_data = {
                ...additional,
            }
            console.log(post_data);

           var w = window.open('', '_blank'); // ← ここでウィンドウ開いておく

            axios.post('/create_pdf', post_data)
              .then((res) => {
                console.log(res);
                    console.log('%c create_pdf', mycolor.api);
                    w.location.href = this.$static_url + res.data;
              })
              .catch( (error) => { console.error(error); });

        }
    }, // methods
}
</script>

<style scoped>
.my_border{
    border: solid 1px #444;
    border-radius: 6px;
    padding: 8px;
}
.blue_border{
    border: solid 1px blue;
}
</style>
